var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../../_snowpack/pkg/react.js";

function SvgLogoSunrise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.178 32 0 24.823 0 16 0 7.178 7.178 0 16 0s16 7.178 16 16c0 8.823-7.178 16-16 16z",
    fill: "#B5728E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.343 16c0-8.086 6.029-14.79 13.828-15.852A16.01 16.01 0 0016 0C7.178 0 0 7.177 0 16c0 8.822 7.178 16 16 16 .736 0 1.46-.052 2.171-.148C10.372 30.789 4.343 24.086 4.343 16z",
    fill: "#776E99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.68 17.523h-5.45a1.362 1.362 0 010-2.725h5.45a1.362 1.362 0 010 2.725z",
    fill: "#DA7F7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.882 17.523h-5.45a1.362 1.362 0 010-2.725h5.45a1.362 1.362 0 010 2.725zM16.056 9.349c-.752 0-1.362-.61-1.362-1.363v-5.45a1.362 1.362 0 012.724 0v5.45c0 .753-.61 1.363-1.362 1.363z",
    fill: "#EBB58A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.056 9.349c.752 0 1.362-.61 1.362-1.363v-5.45c0-.752-.61-1.362-1.362-1.362V9.35zM20.873 11.344a1.362 1.362 0 010-1.927l3.853-3.853a1.362 1.362 0 111.927 1.926l-3.854 3.854a1.362 1.362 0 01-1.926 0z",
    fill: "#DA7F7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.313 11.344L5.459 7.49a1.362 1.362 0 111.927-1.926l3.853 3.853a1.362 1.362 0 11-1.926 1.927z",
    fill: "#EBB58A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.755 20.248H8.357a1.363 1.363 0 01-1.285-.908 9.509 9.509 0 01-.553-3.18c0-5.258 4.278-9.536 9.537-9.536 5.258 0 9.537 4.278 9.537 9.537a9.51 9.51 0 01-.553 3.179 1.362 1.362 0 01-1.285.908z",
    fill: "#FFF2BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.755 20.248c.577 0 1.092-.364 1.285-.908a9.512 9.512 0 00.553-3.18c0-5.258-4.279-9.536-9.537-9.536v13.624h7.7z",
    fill: "#EBB58A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18c.987 7.882 7.73 14 15.876 14 8.145 0 14.888-6.118 15.875-14H0z",
    fill: "#8DA8CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.876 18C30.888 25.882 24.145 32 16 32V18h15.876z",
    fill: "#5689CE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6 29.632A15.904 15.904 0 0015.97 32c3.065 0 5.932-.867 8.369-2.368h-7.14v-3.948h6.748l.504 3.878a16.098 16.098 0 002.258-1.712l-.282-2.166h2.27a16.03 16.03 0 001.5-2.368H26.12l-.513-3.948h5.89l.062.24c.196-.846.324-1.717.38-2.608H0c.055.89.184 1.762.38 2.608l.062-.24h5.89l-.514 3.948H1.742c.43.835.933 1.627 1.498 2.368h2.27l-.28 2.166a16.1 16.1 0 002.257 1.712l.504-3.878h6.748v3.948h-7.14zm7.139-6.316v-3.948H8.81l-.513 3.948h6.44zm2.46-3.948v3.948h6.44l-.512-3.948H17.2z",
    fill: "#5689CE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32h.006a15.904 15.904 0 008.364-2.368h-7.14v-3.948h6.748l.504 3.878a16.1 16.1 0 002.258-1.712l-.282-2.166h2.27a16.03 16.03 0 001.5-2.368H26.15l-.513-3.948h5.89l.062.24c.195-.846.324-1.717.38-2.608H16v15zm7.158-12.632H17.23v3.948h6.44l-.512-3.948z",
    fill: "#3A69C7"
  })));
}

export default SvgLogoSunrise;